import { toRem, toRems } from "../../../../helpers/theme";

/* eslint-disable quote-props, no-dupe-keys, max-len */
const style = ({
    theme,
    isClickable,
    iconLeftAlign,
    hasSpacing,
    isRounded,
    variant,
    isDishTag,
}) => {
    const config = {
        label: {
            size: isDishTag ? 18 : 14,
        },
        icon: {
            size: 14,
        },
        transition: {
            transitionDuration: theme.transitions.pill.default.duration,
            transitionTimingFunction: theme.transitions.pill.default.timingFunction,
            transitionDelay: theme.transitions.pill.default.delay,
        },
    };

    const configVariant = {
        primary: {
            default: {
                border: `1px solid ${theme.colors.pill.primary.border.default}`,
                backgroundColor: theme.colors.pill.primary.background.default,
            },
            hover: {
                borderColor: theme.colors.pill.primary.border.active,
                backgroundColor: theme.colors.pill.primary.background.active,
                color: theme.colors.pill.primary.text.active,
                "& .pill_count": {
                    color: theme.colors.pill.primary.count.active,
                },
            },
        },
        secondary: {
            default: {
                border: `1px solid ${theme.colors.pill.secondary.border.default}`,
                backgroundColor: theme.colors.pill.secondary.background.default,
            },
            hover: {
                borderColor: theme.colors.pill.secondary.border.active,
                backgroundColor: theme.colors.pill.secondary.background.active,
                color: theme.colors.pill.secondary.text.active,
                "& .pill_count": {
                    color: theme.colors.pill.secondary.count.active,
                },
            },
        },
    };

    return {
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "middle",
        margin: 0,
        padding: toRems([6, 10, 8]),
        ...configVariant[variant].default,
        ...(isRounded && {
            borderRadius: theme.global.borderRadius.larger,
        }),
        fontFamily: theme.typography?.font?.default,
        fontWeight: theme.typography.fontWeight.regular,
        fontSize: toRem(config.label.size),
        lineHeight: 1.2,
        textDecoration: "none",
        textAlign: "left",
        wordBreak: "break-word",
        color: theme.colors.pill.primary.text.default,
        ...config?.transition,
        transitionProperty: "color, background-color, border-color",
        cursor: "default",
        ...(hasSpacing && {
            margin: toRems([0, 10, 10, 0]),
        }),
        ...(isClickable && {
            cursor: "pointer",
        }),
        [theme.breakpoints.up("md")]: {
            padding: toRems([6, 12, 8]),
        },
        "&:hover": {
            ...(isClickable && {
                ...configVariant[variant].hover,
            }),
        },
        "& .pill": {
            "&_label": {
                order: iconLeftAlign ? 2 : 1,
                color: "inherit",
            },
            "&_count": {
                marginLeft: toRem(6),
                color: theme.colors.pill.primary.count.default,
                ...config?.transition,
                transitionProperty: "color",
            },
            "&_icon": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                order: 2,
                margin: toRems([3, 0, 0, 7]),
                fontSize: toRem(config.icon.size),
                height: toRem(config.icon.size / 2),
                width: toRem(config.icon.size / 2),
                ...(iconLeftAlign && {
                    order: 1,
                    margin: toRems([3, 7, 0, 0]),
                }),
            },
        },
        svg: {
            path: {
                fill: "currentColor",
            },
        },
    };
};

export default style;
